import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { TimelineActivity } from './timeline.types';

@Component({
  selector: 'timeline-card',
  templateUrl: './timeline-card.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TimelineCardComponent implements OnInit, OnChanges {
  @Input() timelineActivities: TimelineActivity[];
  @Input() title: string = 'Timeline';
  @Input() hideTransactionIds: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}
}
